export default {
  Community: {
    editingCase: {
      titleTextareaPlaceholder: "Descreva o caso ou Faça uma pergunta",
      sybmolCount: "O número de caracteres deve ser de {min} a {max}",
      wordsCount: "O número de palavras deve ser de {min} a {max}",
      mobiledocPlaceholder:
        "Conte-nos mais sobre os dados do exame do paciente",
      mobiledocLabel: "Dados do exame",
      tags: "Tags",
      editCase: "Editar o caso",
      anamnesisPlaceholder:
        "Conte-nos mais sobre o histórico médico do paciente",
      treatmentPlaceholder: "Conte-nos mais sobre o tratamento do paciente",
      caseNotesPlaceholder: "Conte-nos mais sobre o caso",
      questionNotesPlaceholder: "Conte-nos mais sobre a questão",
      addImage: "Anexar uma imagem",
      anamnesis: "Anamnese",
      treatment: "Tratamento",
      notes: "Aditamento",
    },
    uploader: {
      case: {
        title: "Adicionar um caso",
        description: "Compartilhe casos interessantes de sua prática",
      },
      question: {
        title: "Faça uma pergunta",
        description:
          'Os usuários responderão mais rapidamente se você selecionar"pergunta".',
      },
    },
    title: "Comunidade",
    description:
      "Compartilhamento de conhecimento entre médicos sobre casos clínicos",
    all_cases: "Todos os casos",
    my_cases: "Meus casos",
    case: {
      shareLink: {
        1: "Veja o caso",
        2: "na Plataforma “" + process.env.VUE_APP_INSTALL_NAME + "”:",
      },
    },
    noCasesLang: {
      1: "Ainda não há casos publicados neste idioma",
      2: "Seja o primeiro a compartilhar um estudo DICOM e obtenha opiniões de colegas!",
    },
    filter: {
      status: {
        placeholder: "Ordenar casos",
        values: {
          popular: "Populares primeiro",
          actual: "Recentes primeiro",
        },
        options: {
          base: "Mostrar primeiro",
          popular: "Populares",
          actual: "Recentes",
        },
      },
      modality: {
        placeholder: "Modalidade",
      },
      bodypart: {
        placeholder: "Área de estudo",
      },
      sex: {
        placeholder: "Sexo",
        values: {
          M: "Masculino",
          F: "Feminino",
        },
      },
    },
  },
  h1_community: "Comunidade de médicos",
};
